export enum JobType {
	refresh = 'refresh',
	pdf_distribution = 'pdf_distribution'
}
